import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { CheckGameAvailabilityRequest } from "../models/requests/CheckGameAvailabilityRequest";
import { CheckGameMaintenanceRequest } from "../models/requests/CheckGameMaintenanceRequest";
import { CheckGameAvailabilityResponse } from "../models/responses/CheckGameAvailabilityResponse";
import { CheckGameMaintenanceResponse } from "../models/responses/CheckGameMaintenanceResponse";
import { GameProviderResponse } from "../models/responses/GameProviderResponse";

export const gameApi = {
    /* Game availability */
    checkGameAvailability: async (
        request: CheckGameAvailabilityRequest
    ): Promise<UnifiedResponse<CheckGameAvailabilityResponse>> => {
        const response = await apiClient.post<
            UnifiedResponse<CheckGameAvailabilityResponse>
        >("/game_availability", request);

        return response.data;
    },

    /* Game maintenance */
    checkGameMaintenance: async (
        request: CheckGameMaintenanceRequest
    ): Promise<UnifiedResponse<CheckGameMaintenanceResponse>> => {
        const response = await apiClient.post<
            UnifiedResponse<CheckGameMaintenanceResponse>
            >("/game_maintenance", request);
        return response.data;
    },

    /* Game Provider */
    fetchGameProviders: async () => {
        const response = await apiClient.get<
            UnifiedResponse<GameProviderResponse>
            >("/Gameprovider/retrieve", {
            headers: {
                requiresAuth: false,
            },
        });
        return response.data;
    },

    /* Transfer Fund */
    transferFundFromExchange: async () => {
        const response = await apiClient.get<UnifiedResponse<any>>(
            "/game_9w/withdraw",
            {}
        );
        return response.data;
    },
};